import { render, staticRenderFns } from "./tabDialog.vue?vue&type=template&id=2f47ef91&scoped=true"
import script from "./tabDialog.vue?vue&type=script&lang=js"
export * from "./tabDialog.vue?vue&type=script&lang=js"
import style0 from "./tabDialog.vue?vue&type=style&index=0&id=2f47ef91&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f47ef91",
  null
  
)

export default component.exports